<template>
    <div>
      <Head title="Crear tipo de tinda" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-sky-400 hover:text-sky-600" href="/settings/clients/types">Tipos de clientes</Link>
        <span class="text-sky-400 font-medium">/</span> Crear
      </h1>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/2" label="Codigo" />
            <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Descripción" />
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear tipo</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton.vue'
      
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      TextInput,
    },
    layout: Layout,
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          code:'',
          description: '',
        }),
      }
    },
    methods: {
      store() {
        this.form.post('/settings/clients/types/store')
      },
    },
  }
  </script>